export const getUnixTimeStamp = (date: string | number) =>
	Math.floor(new Date(date).getTime() / 1000);
